import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { trackError } from "./userActivityTracker";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // globally default to 10 minutes
      throwOnError: import.meta?.env?.DEV == true,
    },
  },
  queryCache: new QueryCache({
    onError: (error, variables, context) => {
      // Global error handling logic for queries
      console.error(error);
      trackError(error, "QueryClient-QueryError", { variables, context });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, context) => {
      // Global error handling logic for mutations
      console.error(error);
      trackError(error, "QueryClient-MutationError", { variables, context });
    },
  }),
});
